import React, { useEffect, useState,useMemo } from 'react';
import { convert } from 'html-to-text';
import CloseIcon from '@mui/icons-material/Close';
import ChatIcon from '@mui/icons-material/Chat';

import {
  Container, Typography, Box, CircularProgress, Button,
  TextField, IconButton, Modal, Box as MuiBox,
  Switch, FormControlLabel,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,Tooltip,FormControl,Dialog, DialogTitle, DialogContent,
  Chip,
  useMediaQuery,
  useTheme
} from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Autocomplete } from '@mui/material';
import { Link } from '@mui/material';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ExpandLess, ExpandMore, Edit, Delete } from '@mui/icons-material';
import TablePagination from '@mui/material/TablePagination';
import ShareIcon from '@mui/icons-material/Share';
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';

const Opportunity = () => {

  const [options, setOptions] = useState({
      industries: [],
      companies: [],
      roles: [],
    });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [isProvider] = useState(localStorage.getItem('isprovider') === 'yes');
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openFormModal, setOpenFormModal] = useState(false);
  const [openApplyModal, setOpenApplyModal] = useState(false);

  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [editingOpportunity, setEditingOpportunity] = useState(null);

  const [expandedRow, setExpandedRow] = useState(null);
  const [applications, setApplications] = useState({});
  const [loadingApplications, setLoadingApplications] = useState({});

  const [openViewModal, setOpenViewModal] = useState(false);
  const [viewOpportunity, setViewOpportunity] = useState(null);

  //file variables
  const [resumeFiles, setResumeFiles] = useState([]);
  const [uploadedResumeFiles,setUploadedResumeFiles]=useState([])
  const [deletedFileIds, setDeletedFileIds] = useState([]);

  //************************************** */
  //conversation
  const [openConversationAppId, setOpenConversationAppId] = useState(null); // top of component
  const [conversationText, setConversationText] = useState('');
  const [messages, setMessages] = useState({}); // { [appId]: [{ from, message, timestamp }] }
  //******************************************* */

  //*******Filters**************** */
  const [filters, setFilters] = useState({
      opportunity_number: '',
      industry: '',
      company: '',
      role: '',
      link: '',
      comments: '',
      status: ''
    });


  //**************************************************** */
  const [isAdmin, setIsAdmin] = useState(null); 
  const handleViewClick = (opportunity) => {
    setViewOpportunity(opportunity);
    setOpenViewModal(true);
     const url = new URL(window.location);
     url.searchParams.set('opportunity_number', opportunity.opportunity_number);
     window.history.replaceState(null, '', url.toString());
  };

  const handleViewClose = () => {
    setOpenViewModal(false);
    setViewOpportunity(null);
    const url = new URL(window.location);
    url.searchParams.delete('opportunity_number');
    window.history.replaceState(null, '', url.toString());
  };

  const [opportunityForm, setOpportunityForm] = useState({
    industry: '',
    company: '',
    role: '',
    comments: '',
    link: '',
    isActive: true,
  });

  const [isEdit,setisEdit]=useState(false)
  const [editRequestId,seteditRequestId]=useState('')

  const [applyForm, setApplyForm] = useState({ 
    profileSummary: '',
    resumeFile: null,
  });
  const [applyError, setApplyError] = useState('');
  const token = localStorage.getItem('token');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    fetchOpportunities();
    validateAdmin();
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/profile/options`)
          .then(res => setOptions(res.data))
          .catch(err => console.error('Error fetching options:', err));
    // Initial page bootstrap only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const validateAdmin = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsAdmin(false);
      return;
    }

    try {
      await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/validateAdmin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setIsAdmin(true);
    } catch (err) {
      console.error('Admin validation failed:', err);
      setIsAdmin(false);
    }
  };  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oppNum = params.get('opportunity_number');
    if (oppNum) {
      const foundOpp = opportunities.find(o => o.opportunity_number === parseInt(oppNum));
      if (foundOpp) {
        handleApplyClick(foundOpp);
      }
    }
  }, [opportunities]);

  const fetchOpportunities = () => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities`,{
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        const mapped = res.data.map(row => ({
          ...row,
          isActive: row.isActive === true || row.isActive === 'true' || row.isActive === 1 || row.isActive === '1',
        }));
        setOpportunities(mapped);
      })
      .catch(err => console.error('Error fetching opportunities', err))
      .finally(() => setLoading(false));
  };

  const fetchApplications = (opportunity_number) => {
    setLoadingApplications(prev => ({ ...prev, [opportunity_number]: true }));
    var typ = "all"
    if(!isProvider){
      typ = "user"
    }
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications?opportunity_number=${opportunity_number}&type=${typ}`,{
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setApplications(prev => ({ ...prev, [opportunity_number]: res.data }));
      })
      .catch(err => {
        console.error('Error fetching applications for opportunity:', opportunity_number, err);
        setApplications(prev => ({ ...prev, [opportunity_number]: [] }));
      })
      .finally(() => {
        setLoadingApplications(prev => ({ ...prev, [opportunity_number]: false }));
      });
  };

  const handleAddClick = () => {
    setEditingOpportunity(null);
    setOpportunityForm({ industry: '', company: '', role: '', comments: '', link: '', isActive: true });
    setOpenFormModal(true);
  };

  const handleEditClick = (opportunity) => {
    setEditingOpportunity(opportunity);
    setOpportunityForm({
      industry: opportunity.industry || '',
      company: opportunity.company || '',
      role: opportunity.role || '',
      comments: opportunity.comments || '',
      link: opportunity.link || '',
      isActive: opportunity.isActive === 1 || opportunity.isActive === true,
    });
    setOpenFormModal(true);
  };

  const handleDelete = (id) => {
    axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(() => fetchOpportunities())
      .catch(err => console.error('Error deleting opportunity', err));
  };

  const handleFormSubmit = () => {
    const url = editingOpportunity
      ? `${process.env.REACT_APP_API_BASE_URL}/api/opportunities/${editingOpportunity.id}`
      : `${process.env.REACT_APP_API_BASE_URL}/api/opportunities`;

    const method = editingOpportunity ? 'put' : 'post';

    axios[method](url, opportunityForm, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(() => {
        fetchOpportunities();
        setOpenFormModal(false);
      })
      .catch(err => console.error('Error submitting opportunity', err));
  };

  const handleApplyClick = (opportunity) => {
    setSelectedOpportunity(opportunity);
    setApplyForm({
      profileSummary: '',
      resumeFile: null,
    });
    setApplyError('');
    setOpenApplyModal(true);
    // Update URL param for direct link
    const url = new URL(window.location);
    url.searchParams.set('opportunity_number', opportunity.opportunity_number);
    window.history.replaceState(null, '', url.toString());
  };

  const sendMessage = async (appId, message,conversationText,opportunity_number) => {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/${appId}/conversations`,{
        message: conversationText,
        opportunitynumber:opportunity_number
      }, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          return
        })
        .catch(err => {
          alert("Error updating Comments.");
        });
  };


  const fetchMessages = async (appId) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/${appId}/conversations`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  } catch (err) {
    alert("Error fetching comments.");
    return []; // Return an empty array to avoid crashes
  }
};

  const handleOpenConversation = async (applicationId) => {
      setOpenConversationAppId(applicationId);
      setConversationText('')
      setMessages({})
      const msgs = await fetchMessages(applicationId);
      setMessages({ [applicationId]: msgs }); // Only store current
  };

  const handleApplyOrEditClick = (opportunity, isEdit) => {
      seteditRequestId('')
      setisEdit(true)
      setSelectedOpportunity(opportunity);
      setApplyError('');
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/user?opportunity_number=${opportunity.opportunity_number}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          const app = res.data;
          seteditRequestId(app.id)
          setApplyForm({
            profileSummary: app.profile_summary || ''
          });
          setUploadedResumeFiles(app.attachments || []);
          setResumeFiles([]);
          setDeletedFileIds([]);
          setOpenApplyModal(true);
        })
        .catch(err => {
          console.error('Error fetching existing application:', err);
          // If error, fallback to blank form
          setApplyForm({ profileSummary: '' });
          setUploadedResumeFiles([]);
          setResumeFiles([]);
          setDeletedFileIds([]);
          setOpenApplyModal(false);
          setisEdit(false)
          seteditRequestId('')
        });

    // Update URL param for direct link (optional)
    const url = new URL(window.location);
    url.searchParams.set('opportunity_number', opportunity.opportunity_number);
    window.history.replaceState(null, '', url.toString());
  };


  const handleApplyClose = () => {
    setOpenApplyModal(false);
    setSelectedOpportunity(null);
    setApplyForm({
      profileSummary: '',
      resumeFile: null,
    });

     setUploadedResumeFiles([]);
     setResumeFiles([]);
     setDeletedFileIds([]);
     setisEdit(false)
     seteditRequestId('')

    // Clean URL param on close
    const url = new URL(window.location);
    url.searchParams.delete('opportunity_number');
    window.history.replaceState(null, '', url.toString());
  };

  const handleApplySubmit = () => {
    setApplyError('');
    if (!applyForm.profileSummary) {
      setApplyError('Please fill all required fields.');
      return;
    }
    // if(!isEdit){
    //   if (resumeFiles.length==0) {
    //     setApplyError('Please upload Resume and other documents.');
    //     return;
    //   }
    // }
    const formData = new FormData();
    formData.append('opportunity_number', selectedOpportunity.opportunity_number); 
    formData.append('profileSummary', applyForm.profileSummary);
    resumeFiles.forEach((file, index) => {
        formData.append('attachments', file); // name 'attachments' should match backend field name
    });
    if(isEdit){
      formData.append('deletedFileIds', JSON.stringify(deletedFileIds))
      axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/update/${editRequestId}`, formData, 
        {
      headers: {
         Authorization: `Bearer ${token}`,
      },
      })
      .then(() => {
          alert('Application updated successfully!'); 
          handleApplyClose();
          fetchOpportunities()
        })
        .catch(err => {
          console.error('Error updating application:', err);
          setApplyError('Failed to submit application. Please try again.');
      });
    }else{
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications`, formData, {
      headers: {
         Authorization: `Bearer ${token}`,
      },
      })
      .then(() => {
          alert('Application submitted successfully!'); 
          handleApplyClose();
          fetchOpportunities()
        })
        .catch(err => {
          console.error('Error submitting application:', err);
          setApplyError('Failed to submit application. Please try again.');
      });
    }
  };

  const toggleExpandRow = (opportunity_number) => {
  if (expandedRow === opportunity_number) {
    // Collapse if already expanded
    setExpandedRow(null);
  } else {
    setExpandedRow(opportunity_number);
    if (applications[opportunity_number]) {
      const updatedApplications = { ...applications };
      delete updatedApplications[opportunity_number];
      setApplications(updatedApplications);
    }
    fetchApplications(opportunity_number);
  }
};
  // const filteredOpportunities = opportunities.filter(opp =>
  //   opp.industry.toLowerCase().includes(filter.toLowerCase()) ||
  //   opp.company.toLowerCase().includes(filter.toLowerCase()) ||
  //   opp.role.toLowerCase().includes(filter.toLowerCase())||
  //   opp.opportunity_number==filter
  // );

  const filteredOpportunities = useMemo(() => {
  return opportunities.filter((opp) => {
    return (
      (!filters.opportunity_number || String(opp.opportunity_number).toLowerCase().includes(filters.opportunity_number.toLowerCase())) &&
      (!filters.industry || opp.industry.toLowerCase().includes(filters.industry.toLowerCase())) &&
      (!filters.company || opp.company.toLowerCase().includes(filters.company.toLowerCase())) &&
      (!filters.role || opp.role.toLowerCase().includes(filters.role.toLowerCase())) &&
      (!filters.link || opp.link.toLowerCase().includes(filters.link.toLowerCase())) &&
      (!filters.comments || (opp.comments || '').toLowerCase().includes(filters.comments.toLowerCase())) &&
      (!filters.status || (opp.isActive ? 'active' : 'inactive').includes(filters.status.toLowerCase()))
    );
  });
}, [opportunities, filters]);


  const columns = [
    {
      field: 'expand',
      headerName: '',
      width: 50,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const oppNum = params.row?.opportunity_number;
        if (!oppNum) return null;
        return (
          <IconButton size="small" onClick={() => toggleExpandRow(oppNum)}>
            {expandedRow ? <ExpandLess  /> : <ExpandMore  />}
          </IconButton>
        );
      }
    },
    { field: 'industry', headerName: 'Industry', width: 130 },
    { field: 'company', headerName: 'Company', width: 170 },
    { field: 'role', headerName: 'Role', width: 150 },
    { field: 'link', headerName: 'Link', width: 180 },
    { field: 'comments', headerName: 'Comments', width: 180 },
    {
      field: 'isActive',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => (params.row?.isActive ? 'Active' : 'Inactive'),
    }
  ];

  if (isProvider) {
    columns.push({
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEditClick(params.row)}>
            <EditIcon />
          </IconButton>
          <IconButton color="error" onClick={() => handleDelete(params.row.id)}>
            <DeleteIcon />
          </IconButton>
        </>
      ),
    });
  }
  const paginatedOpportunities = filteredOpportunities.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const activeOpportunitiesCount = opportunities.filter((opportunity) => opportunity.isActive).length;
  const appliedOpportunitiesCount = opportunities.filter((opportunity) => !opportunity.allow_apply).length;
  const hasActiveFilters = Object.values(filters).some(Boolean);
  const compactDescription = (html) => {
    const text = convert(html || '', {
      wordwrap: false,
      limits: { maxInputLength: 500 },
    }).trim();
    return text || 'No description added yet.';
  };

  const shareOpportunity = (opportunity) => {
    const shareUrl = `${window.location.origin}${window.location.pathname}?opportunity_number=${opportunity.opportunity_number}`;
    navigator.clipboard.writeText(shareUrl);
    alert('Opportunity link copied to clipboard!');
  };

  const clearFilters = () => {
    setFilters({
      opportunity_number: '',
      industry: '',
      company: '',
      role: '',
      link: '',
      comments: '',
      status: ''
    });
    setPage(0);
  };

  const renderApplicationsPanel = (opportunity) => (
    <Box sx={{
            mt: 1.5,
            p: { xs: 1.5, sm: 2 },
            border: '1px solid #dbeafe',
            borderRadius: 2,
            bgcolor: '#f8fafc',
            fontSize: { xs: 12, sm: 14 },
            overflowWrap: 'break-word',
          }}>
      <Typography variant="h6" fontSize={{ xs: 15, sm: 18 }} sx={{ color: '#0f172a', fontWeight: 900, mb: 1.5 }}>
        Applications for Opportunity #{opportunity.opportunity_number}
      </Typography>

      {loadingApplications[opportunity.opportunity_number] ? (
        <CircularProgress size={24} />
      ) : (
        <>
          {applications[opportunity.opportunity_number]?.length > 0 ? (
            applications[opportunity.opportunity_number].map(app => (
              <Box
                key={app.id}
                sx={{
                  mb: 2,
                  p: 1.5,
                  border: '1px solid #e2e8f0',
                  borderRadius: 2,
                  bgcolor: 'white',
                  fontSize: { xs: 12, sm: 14 },
                }}
              >
                <Typography><strong>Name:</strong> {app.name}</Typography>
                <Typography><strong>Mobile:</strong> {app.mobile}</Typography>
                <Typography><strong>Email:</strong> {app.email}</Typography>
                <Typography><strong>Profile Summary:</strong> {app.profile_summary}</Typography>
                {app.attachments ? (
                  <Typography sx={{ mt: 1 }}>
                    <strong>Resume:</strong>{' '}
                    {app.attachments?.map((file) => (
                      <Box key={file.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Link
                          href={`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/${file.id}/resume`}
                          target="_blank"
                          rel="noopener noreferrer"
                          underline="hover"
                        >
                          {file.filename}
                        </Link>
                      </Box>
                    ))}
                  </Typography>
                ) : (
                  <Typography sx={{ mt: 1 }}>No Attachments Uploaded</Typography>
                )}
                <Button
                  size="small"
                  startIcon={<ChatIcon />}
                  onClick={() => handleOpenConversation(app.id)}
                  sx={{ mt: 1, fontWeight: 800 }}
                >
                  Conversation
                </Button>
                <Dialog
                  open={openConversationAppId === app.id}
                  onClose={() => setOpenConversationAppId(null)}
                  fullWidth
                  fullScreen={isMobile}
                  maxWidth="sm"
                  PaperProps={{ sx: { borderRadius: { xs: 0, sm: 3 } } }}
                >
                  <DialogTitle
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      fontWeight: 900,
                      color: '#0f172a',
                    }}
                  >
                    <Typography sx={{ fontWeight: 900, minWidth: 0 }}>
                      Conversation with {app.name}
                    </Typography>
                    <IconButton
                      aria-label="Close conversation"
                      onClick={() => setOpenConversationAppId(null)}
                      edge="end"
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent dividers>
                    <Box sx={{ maxHeight: 300, overflowY: 'auto', mb: 2, px: 1 }}>
                      {(messages[app.id] || []).map((msg, idx) => {
                        const isCurrentUser = msg.currentuser === 1;
                        return (
                          <Box
                            key={idx}
                            sx={{
                              display: 'flex',
                              justifyContent: isCurrentUser ? 'flex-end' : 'flex-start',
                              mb: 1,
                            }}
                          >
                            <Box
                              sx={{
                                p: 1.5,
                                maxWidth: '75%',
                                bgcolor: isCurrentUser ? '#0f766e' : '#f1f5f9',
                                color: isCurrentUser ? 'white' : '#0f172a',
                                borderRadius: 2,
                                borderTopLeftRadius: isCurrentUser ? 8 : 0,
                                borderTopRightRadius: isCurrentUser ? 0 : 8,
                                fontSize: 14,
                                wordBreak: 'break-word',
                              }}
                            >
                              {!isCurrentUser&&(
                                <Typography variant="caption" sx={{ display: 'block', mt: 0.5, opacity: 0.7 }}>
                                  From:{msg.first_name}
                                </Typography>
                              )}
                              <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                {msg.message}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ display: 'block', mt: 0.5, textAlign: 'right', opacity: 0.7 }}
                              >
                                {new Date(msg.created_at).toLocaleString()}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>

                    <TextField
                      fullWidth
                      multiline
                      rows={2}
                      label="Your message"
                      value={conversationText}
                      onChange={(e) => setConversationText(e.target.value)}
                    />
                    <Button
                      sx={{ mt: 1, bgcolor: '#0f766e', '&:hover': { bgcolor: '#115e59' } }}
                      variant="contained"
                      disabled={!conversationText.trim()}
                      onClick={async () => {
                        if (!conversationText.trim()) return;
                        await sendMessage(app.id, isProvider ? 'provider' : 'applicant', conversationText,opportunity.opportunity_number);
                        const updatedMsgs = await fetchMessages(app.id);
                        setMessages({ [app.id]: updatedMsgs });
                        setConversationText('');
                      }}
                    >
                      Send
                    </Button>
                  </DialogContent>
                </Dialog>
              </Box>
            ))
          ) : (
            <Typography>No applications yet.</Typography>
          )}
        </>
      )}
    </Box>
  );
return (
  <Box
    sx={{
      minHeight: '100vh',
      mx: { xs: -2, sm: -3, md: -4 },
      my: { xs: -2, sm: -3, md: -4 },
      px: { xs: 2, sm: 3, md: 4 },
      py: { xs: 3, md: 5 },
      background:
        'radial-gradient(circle at 12% 12%, rgba(20, 184, 166, 0.16), transparent 30%), radial-gradient(circle at 88% 4%, rgba(37, 99, 235, 0.13), transparent 28%), linear-gradient(135deg, #f8fafc 0%, #eef7f6 48%, #f8fafc 100%)',
    }}
  >
  <Container maxWidth="lg" disableGutters>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', lg: '1.45fr 1fr' },
        gap: 2.5,
        alignItems: 'stretch',
        mb: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2.5, md: 4 },
          borderRadius: 4,
          border: '1px solid rgba(15, 118, 110, 0.14)',
          boxShadow: '0 24px 70px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Chip
          label="Udyog Connect Opportunities"
          sx={{
            mb: 2,
            bgcolor: '#e6fffb',
            color: '#0f766e',
            border: '1px solid #99f6e4',
            fontWeight: 800,
          }}
        />
        <Typography
          variant={isMobile ? 'h4' : 'h3'}
          sx={{ color: '#0f172a', fontWeight: 900, lineHeight: 1.08, mb: 1.5 }}
        >
          Discover roles, apply with context, and manage responses.
        </Typography>
        <Typography sx={{ color: '#475569', maxWidth: 760, lineHeight: 1.7 }}>
          Browse community opportunities by industry, company, and role. Providers can publish
          openings and review applications, while members can apply and continue conversations.
        </Typography>
      </Paper>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)', lg: '1fr' },
          gap: 1.5,
        }}
      >
        {[
          { label: 'Total opportunities', value: opportunities.length },
          { label: 'Active now', value: activeOpportunitiesCount },
          { label: isProvider ? 'Your role' : 'Applied by you', value: isProvider ? 'Provider' : appliedOpportunitiesCount },
        ].map((stat) => (
          <Paper
            key={stat.label}
            elevation={0}
            sx={{
              p: 2,
              borderRadius: 3,
              border: '1px solid rgba(15, 118, 110, 0.12)',
              bgcolor: 'rgba(255, 255, 255, 0.82)',
              boxShadow: '0 16px 40px rgba(15, 23, 42, 0.06)',
            }}
          >
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800, textTransform: 'uppercase' }}>
              {stat.label}
            </Typography>
            <Typography sx={{ color: '#0f172a', fontWeight: 900, mt: 0.75 }}>
              {stat.value}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>

    <Paper
      elevation={0}
      sx={{
        p: { xs: 1.5, sm: 2, md: 3 },
        borderRadius: 4,
        border: '1px solid rgba(15, 118, 110, 0.13)',
        boxShadow: '0 22px 70px rgba(15, 23, 42, 0.08)',
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'stretch', md: 'center' },
          gap: 2,
          mb: 2.5,
        }}
      >
        <Box>
          <Typography variant="h5" sx={{ color: '#0f172a', fontWeight: 900 }}>
            Opportunity board
          </Typography>
          <Typography sx={{ color: '#64748b', mt: 0.5 }}>
            Filter, share, apply, and review applications from one workspace.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: { xs: 'stretch', sm: 'flex-end' } }}>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={fetchOpportunities}
            sx={{ borderColor: '#0f766e', color: '#0f766e', fontWeight: 800, flex: { xs: 1, sm: 'initial' } }}
          >
            Refresh
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            sx={{ bgcolor: '#0f766e', '&:hover': { bgcolor: '#115e59' }, fontWeight: 800, flex: { xs: 1, sm: 'initial' } }}
          >
            Add Opportunity
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(5, minmax(0, 1fr))' },
          gap: 1.5,
          mb: 2.5,
        }}
      >
        <TextField size="small" label="Opportunity number" value={filters.opportunity_number} onChange={(e) => setFilters({ ...filters, opportunity_number: e.target.value })} />
        <TextField size="small" label="Industry" value={filters.industry} onChange={(e) => setFilters({ ...filters, industry: e.target.value })} />
        <TextField size="small" label="Company" value={filters.company} onChange={(e) => setFilters({ ...filters, company: e.target.value })} />
        <TextField size="small" label="Role" value={filters.role} onChange={(e) => setFilters({ ...filters, role: e.target.value })} />
        <TextField size="small" label="Status" value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })} />
      </Box>
      {hasActiveFilters && (
        <Button size="small" onClick={clearFilters} sx={{ mb: 2, color: '#0f766e', fontWeight: 800 }}>
          Clear filters
        </Button>
      )}

    {loading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress />
      </Box>
    ) : (
      <>
        {isMobile ? (
          <Box sx={{ display: 'grid', gap: 1.5 }}>
            {paginatedOpportunities.length === 0 ? (
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  border: '1px solid #e2e8f0',
                  bgcolor: '#f8fafc',
                  textAlign: 'center',
                }}
              >
                <Typography sx={{ color: '#0f172a', fontWeight: 800 }}>No opportunities found</Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.75 }}>
                  Adjust your filters or refresh the opportunity board.
                </Typography>
              </Paper>
            ) : (
              paginatedOpportunities.map((opportunity) => (
                <Paper
                  key={opportunity.id}
                  elevation={0}
                  sx={{
                    p: 2,
                    borderRadius: 3,
                    border: '1px solid #e2e8f0',
                    bgcolor: '#ffffff',
                    boxShadow: '0 10px 28px rgba(15, 23, 42, 0.06)',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'flex-start' }}>
                    <Box>
                      <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800 }}>
                        Opportunity #{opportunity.opportunity_number}
                      </Typography>
                      <Typography sx={{ color: '#0f172a', fontWeight: 900, mt: 0.25 }}>
                        {opportunity.role || 'Opportunity'}
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#475569', mt: 0.25 }}>
                        {[opportunity.company, opportunity.industry].filter(Boolean).join(' • ')}
                      </Typography>
                    </Box>
                    <Chip
                      size="small"
                      label={opportunity.isActive ? 'Active' : 'Inactive'}
                      color={opportunity.isActive ? 'success' : 'default'}
                    />
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#475569',
                      mt: 1.25,
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {compactDescription(opportunity.comments)}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1.5 }}>
                    <Button size="small" variant="outlined" startIcon={<VisibilityIcon />} onClick={() => handleViewClick(opportunity)}>
                      View
                    </Button>
                    {opportunity.allow_apply ? (
                      <Button size="small" variant="contained" startIcon={<SendIcon />} onClick={() => handleApplyClick(opportunity)} sx={{ bgcolor: '#0f766e', '&:hover': { bgcolor: '#115e59' } }}>
                        Apply
                      </Button>
                    ) : (
                      <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={() => handleApplyOrEditClick(opportunity)}>
                        Edit Application
                      </Button>
                    )}
                    <Button size="small" variant="outlined" startIcon={<ShareIcon />} onClick={() => shareOpportunity(opportunity)}>
                      Share
                    </Button>
                    <Button size="small" variant="text" onClick={() => toggleExpandRow(opportunity.opportunity_number)}>
                      {expandedRow === opportunity.opportunity_number ? 'Hide Applications' : `Applications (${opportunity.noapplications || 0})`}
                    </Button>
                    <Button size="small" variant="text" disabled={!opportunity.allow_edit && !isAdmin} startIcon={<Edit />} onClick={() => handleEditClick(opportunity)}>
                      Edit
                    </Button>
                    <Button size="small" color="error" variant="text" disabled={!opportunity.allow_edit && !isAdmin} startIcon={<Delete />} onClick={() => handleDelete(opportunity.id)}>
                      Delete
                    </Button>
                  </Box>
                  <Collapse in={expandedRow === opportunity.opportunity_number} timeout="auto" unmountOnExit>
                    {renderApplicationsPanel(opportunity)}
                  </Collapse>
                </Paper>
              ))
            )}
            <TablePagination
              component="div"
              count={filteredOpportunities.length}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Box>
        ) : (
        <div>
          <Box sx={{
              overflowX: 'auto',
              '& table': {
                minWidth: 900,
                borderCollapse: 'separate',
                borderSpacing: '0',
              },
              '& th, & td': {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                maxWidth: 200,
                fontSize: { xs: '12px', sm: '14px' },
                textAlign: 'left',
                padding: '8px',
              },
              '& thead th': {
                backgroundColor: '#f5f5f5',
                fontWeight: 600,
              },
              '& .MuiTablePagination-toolbar': {
                flexWrap: 'wrap',
                justifyContent: 'center',
              },
            }}>
            <TableContainer component={Paper} sx={{ borderRadius: 3, border: '1px solid #e2e8f0', boxShadow: 'none' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {<TableCell />}
                    <TableCell>View</TableCell>
                    <TableCell>Apply</TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        value={filters.opportunity_number}
                        onChange={(e) =>
                          setFilters({ ...filters, opportunity_number: e.target.value })
                        }
                        placeholder="Number"
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        value={filters.industry}
                        onChange={(e) =>
                          setFilters({ ...filters, industry: e.target.value })
                        }
                        placeholder="Industry"
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        value={filters.company}
                        onChange={(e) =>
                          setFilters({ ...filters, company: e.target.value })
                        }
                        placeholder="Company"
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        value={filters.role}
                        onChange={(e) =>
                          setFilters({ ...filters, role: e.target.value })
                        }
                        placeholder="Role"
                      />
                    </TableCell>
                    <TableCell>Link</TableCell>
                    <TableCell>Comments</TableCell>
                    <TableCell>Applications</TableCell>   
                    <TableCell>
                      <TextField
                        variant="standard"
                        value={filters.status}
                        onChange={(e) =>
                          setFilters({ ...filters, status: e.target.value })
                        }
                        placeholder="Status"
                      />
                    </TableCell>    
                    
                    {<TableCell>Actions</TableCell>}
                  </TableRow>
                 
                </TableHead>
                <TableBody>
                  {filteredOpportunities.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(opportunity => (
                    <React.Fragment key={opportunity.id}>
                      <TableRow key={opportunity.id} sx={{ height: '48px' }}>
                        {<TableCell>
                          <IconButton onClick={() => toggleExpandRow(opportunity.opportunity_number)}>
                            {expandedRow === opportunity.opportunity_number ? <ExpandLess /> : <ExpandMore />}
                          </IconButton>
                        </TableCell>}

                        <TableCell>
                        <Tooltip title="View Details">
                            <IconButton onClick={() => handleViewClick(opportunity)} color="info">
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          {opportunity.allow_apply ? (
                            <Tooltip title="Apply">
                              <IconButton
                                color="primary"
                                onClick={() => handleApplyClick(opportunity)}
                              >
                                <SendIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Edit Application">
                              <IconButton
                                color="secondary"
                                onClick={() => handleApplyOrEditClick (opportunity)}
                              >
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>

                        <TableCell>{opportunity.opportunity_number}</TableCell>                      
                        <TableCell>{opportunity.industry}</TableCell>
                        <TableCell>{opportunity.company}</TableCell>
                        <TableCell>{opportunity.role}</TableCell>
                        <TableCell>{opportunity.link}</TableCell>                    
                        <TableCell>
                          <Tooltip
                            title={
                              <div dangerouslySetInnerHTML={{ __html: opportunity.comments }} />
                            }
                            placement="top"
                            arrow
                          >
                            <span
                              style={{
                                display: 'inline-block',
                                maxWidth: 150,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                verticalAlign: 'middle',
                              }}
                            >
                              {convert(opportunity.comments || '', {
                                wordwrap: false,
                                limits: { maxInputLength: 100 },
                              })
                                .split(' ')
                                .slice(0, 3)
                                .join(' ') + '...'}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{opportunity.noapplications}</TableCell>
                        <TableCell>{opportunity.isActive ? 'Active' : 'Inactive'}</TableCell> 
                        <TableCell sx={{
                                          minWidth: 150,
                                          whiteSpace: 'nowrap',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 1, // optional spacing
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                        }}>
                            <IconButton disabled={!opportunity.allow_edit && !isAdmin} onClick={() => handleEditClick(opportunity)} color="primary">
                              <Edit />
                            </IconButton>
                            <IconButton disabled={!opportunity.allow_edit && !isAdmin} onClick={() => handleDelete(opportunity.id)} color="error">
                              <Delete />
                            </IconButton>
                            <Tooltip title="Copy Shareable Link"> 
                            <IconButton
                            onClick={() => shareOpportunity(opportunity)}
                          >
                            <ShareIcon />
                            </IconButton>
                            </Tooltip>
                          </TableCell>
                      </TableRow>

                      {/* Collapsible row */}
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={isProvider ? 10 : 9}>
                          <Collapse in={expandedRow === opportunity.opportunity_number} timeout="auto" unmountOnExit>
                            <Box sx={{
                                    mb: 2,
                                    p: 2,
                                    border: '1px solid #ccc',
                                    borderRadius: 1,
                                    bgcolor: 'white',
                                    fontSize: { xs: 12, sm: 14 },
                                    overflowWrap: 'break-word',
                                  }}>
                              {/* gutterBottom */}
                              <Typography variant="h6"   fontSize={{ xs: 16, sm: 20 }}>
                                Applications for Opportunity #{opportunity.opportunity_number}
                              </Typography>

                              {loadingApplications[opportunity.opportunity_number] ? (
                                <CircularProgress />
                              ) : (
                                <>
                                  {applications[opportunity.opportunity_number]?.length > 0 ? (
                                    applications[opportunity.opportunity_number].map(app => (
                                      <Box
                                        key={app.id}
                                        sx={{
                                          mb: 2,
                                          p: 2,
                                          border: '1px solid #ccc',
                                          borderRadius: 1,
                                          bgcolor: 'white',
                                          fontSize: { xs: 12, sm: 14 },
                                        }}
                                      > 
                                        <Typography><strong>Name:</strong> {app.name}</Typography>
                                        <Typography><strong>Mobile:</strong> {app.mobile}</Typography>
                                        <Typography><strong>Email:</strong> {app.email}</Typography>
                                        <Typography><strong>Profile Summary:</strong> {app.profile_summary}</Typography>
                                        {app.attachments ? (
                                          <Typography sx={{ mt: 1 }}>
                                            <strong>Resume:</strong>{' '}                                          
                                            {app.attachments?.map((file, index) => (
                                              <Box key={file.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Link
                                                  href={`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/${file.id}/resume`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  underline="hover"
                                                >
                                                  {file.filename}
                                                </Link>
                                              </Box>
                                            ))}                                     
                                          </Typography>
                                        ) : (
                                          <Typography sx={{ mt: 1 }}>No Attachments Uploaded</Typography>
                                        )}
                                        <IconButton
                                          onClick={() => handleOpenConversation(app.id)}
                                          aria-label="Open Conversation"
                                        >
                                          <ChatIcon />
                                        </IconButton>
                                        {/* 💬 Conversation Dialog */}
                                        <Dialog
                                          open={openConversationAppId === app.id}
                                          onClose={() => setOpenConversationAppId(null)}
                                          fullWidth
                                          maxWidth="sm"
                                        >
                                          <DialogTitle>Conversation with {app.name}</DialogTitle>
                                          <DialogContent dividers>
                                                {/* Chat container */}
                                                <Box sx={{ maxHeight: 300, overflowY: 'auto', mb: 2, px: 1 }}>
                                                  {(messages[app.id] || []).map((msg, idx) => {
                                                    const isCurrentUser = msg.currentuser === 1;
                                                    return (
                                                      <Box
                                                        key={idx}
                                                        sx={{
                                                          display: 'flex',
                                                          justifyContent: isCurrentUser ? 'flex-end' : 'flex-start',
                                                          mb: 1,
                                                        }}
                                                      >
                                                        <Box
                                                          sx={{
                                                            p: 1.5,
                                                            maxWidth: '75%',
                                                            bgcolor: isCurrentUser ? '#1976d2' : '#f1f1f1',
                                                            color: isCurrentUser ? 'white' : 'black',
                                                            borderRadius: 2,
                                                            borderTopLeftRadius: isCurrentUser ? 8 : 0,
                                                            borderTopRightRadius: isCurrentUser ? 0 : 8,
                                                            fontSize: 14,
                                                            wordBreak: 'break-word',
                                                          }}
                                                        >
                                                          {!isCurrentUser&&(
                                                            <Typography variant="caption" sx={{ display: 'block', mt: 0.5, opacity: 0.7 }}>                                   
                                                              From:{msg.first_name}
                                                            </Typography>
                                                          )}
                                                          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>                                                           
                                                            {msg.message}
                                                          </Typography>
                                                          <Typography
                                                            variant="caption"
                                                            sx={{ display: 'block', mt: 0.5, textAlign: 'right', opacity: 0.7 }}
                                                          >
                                                            {new Date(msg.created_at).toLocaleString()}
                                                          </Typography>
                                                        </Box>
                                                      </Box>
                                                    );
                                                  })}
                                                </Box>

                                                {/* Input box */}
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={2}
                                                  label="Your message"
                                                  value={conversationText}
                                                  onChange={(e) => setConversationText(e.target.value)}
                                                />
                                                <Button
                                                  sx={{ mt: 1 }}
                                                  variant="contained"
                                                  disabled={!conversationText.trim()}
                                                  onClick={async () => {
                                                    if (!conversationText.trim()) return;
                                                    await sendMessage(app.id, isProvider ? 'provider' : 'applicant', conversationText,opportunity.opportunity_number);
                                                    const updatedMsgs = await fetchMessages(app.id);
                                                    setMessages({ [app.id]: updatedMsgs });
                                                    setConversationText('');
                                                  }}
                                                >
                                                  Send
                                                </Button>
                                              </DialogContent>
                                        </Dialog>
                                      </Box>
                                    ))
                                  ) : (
                                    <Typography>No applications yet.</Typography>
                                  )}
                                </>

                              )}
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredOpportunities.length}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Box>
        </div>
        )}
      </>
    )}

    </Paper>

    {/* Add/Edit Opportunity Modal */}
    <Modal open={openFormModal} onClose={() => setOpenFormModal(false)}>
      <MuiBox
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 2,
            width: { xs: '90vw', sm: 400 },
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: '90vh',
            overflowY: 'auto',
            border: '1px solid #e2e8f0',
          }}
      >
        <Typography variant="h6" gutterBottom>
          {editingOpportunity ? 'Edit Opportunity' : 'Add Opportunity'}
        </Typography>

        <Autocomplete
          freeSolo
          fullWidth
          options={options.industries}
          value={opportunityForm.industry}
          onChange={(e, newVal) => setOpportunityForm(prev => ({ ...prev, industry: newVal || '' }))}
          onInputChange={(e, newInputValue) => {
            setOpportunityForm(prev => ({ ...prev, industry: newInputValue }));
          }}
          renderInput={(params) => <TextField {...params} label="Industry" margin="normal" />}
        />
        <Autocomplete
          freeSolo
          fullWidth
          options={options.companies}
          value={opportunityForm.company}
          onChange={(e, newVal) => setOpportunityForm(prev => ({ ...prev, company: newVal || '' }))}
          onInputChange={(e, newInputValue) => {
            setOpportunityForm(prev => ({ ...prev, company: newInputValue }));
          }}
          renderInput={(params) => <TextField {...params} label="Company" margin="normal" />}
        />
        <Autocomplete
          freeSolo
          fullWidth
          options={options.roles}
          value={opportunityForm.role}
          onChange={(e, newVal) => setOpportunityForm(prev => ({ ...prev, role: newVal || '' }))}
          onInputChange={(e, newInputValue) => {
            setOpportunityForm(prev => ({ ...prev, role: newInputValue }));
          }}
          renderInput={(params) => <TextField {...params} label="Role" margin="normal" />}
        />
      <>
        <label
          htmlFor="job-description"
          style={{
            display: 'block',
            marginBottom: 4,
            fontSize: '0.875rem',
            fontWeight: 500,
            color: 'rgba(0, 0, 0, 0.6)', // Matches MUI's default label color
          }}
        >
          Job Description
        </label>
        <ReactQuill
          id="job-description"
          theme="snow"
          value={opportunityForm.comments}
          onChange={content =>
            setOpportunityForm(prev => ({ ...prev, comments: content }))
          }
          style={{
            height: 144, // ~6 rows
            overflowY: 'auto',
            borderRadius: 4,
            border: '1px solid rgba(0, 0, 0, 0.23)', // MUI-like border
            boxSizing: 'border-box',
            marginBottom: 16, // Like sx={{ mb: 2 }}
          }}
          modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
          }}
        />
        </>
        {/* <TextField
          label="Job Description"
          fullWidth
          multiline
          value={opportunityForm.comments}
          rows={6}
          onChange={e => setOpportunityForm(prev => ({ ...prev, comments: e.target.value }))}
          sx={{ mb: 2, '& .MuiInputBase-root': {
      overflow: 'auto' // Enables scroll inside the textarea
        } }}
        /> */}
        <TextField
          label="Link"
          fullWidth
          value={opportunityForm.link}
          onChange={e => setOpportunityForm(prev => ({ ...prev, link: e.target.value }))}
          sx={{ mb: 2 }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={opportunityForm.isActive}
              onChange={e => setOpportunityForm(prev => ({ ...prev, isActive: e.target.checked }))}
            />
          }
          label="Active"
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => setOpenFormModal(false)} sx={{ mr: 1, fontWeight: 800 }}>Cancel</Button>
          <Button variant="contained" onClick={handleFormSubmit} sx={{ bgcolor: '#0f766e', '&:hover': { bgcolor: '#115e59' }, fontWeight: 800 }}>
            {editingOpportunity ? 'Update' : 'Add'}
          </Button>
        </Box>
      </MuiBox>
    </Modal>

    {/* Apply Modal */}
    <Modal open={openApplyModal} onClose={handleApplyClose}>
      <MuiBox
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          p: { xs: 2, sm: 4 },
          width: { xs: '92vw', sm: 460 },
          borderRadius: 2,
          boxShadow: 24,
          maxHeight: '90vh',
          overflowY: 'auto',
          border: '1px solid #e2e8f0',
        }}
      >
        <Typography variant="h6" gutterBottom>
          
          {isEdit?'Edit Application for ' :'Apply for '}Opportunity #{selectedOpportunity?.opportunity_number} - {selectedOpportunity?.role}
        </Typography>
        <TextField
          label="Profile Summary"
          fullWidth
          multiline
          rows={3}
          value={applyForm.profileSummary}
          onChange={e => setApplyForm(prev => ({ ...prev, profileSummary: e.target.value }))}
          sx={{ mb: 2 }}
        />
        <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            {/* Upload Button */}
            <Button
              variant="outlined"
              component="label"
              sx={{ mb: 0, borderColor: '#0f766e', color: '#0f766e', fontWeight: 800, width: { xs: '100%', sm: 'auto' } }}
            >
              Upload Attachments
              <input
                  type="file"
                  hidden
                  multiple
                  accept=".pdf,.doc,.docx"
                  onChange={e => {
                    const filesArray = Array.from(e.target.files);
                    setResumeFiles(prev => [...prev, ...filesArray]);
                  }}
                />
            </Button>
            {/* Show existing uploaded resume link */}
            {uploadedResumeFiles?.map((file, index) => (
              <Box key={file.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Link
                  href={`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/${file.id}/resume`}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                >
                  {file.filename}
                </Link>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => {
                    setUploadedResumeFiles(prev => prev.filter((_, i) => i !== index));
                    setDeletedFileIds(prev => [...prev, file.id]); // Track deleted file
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
            {/* Show newly selected resume file */}
            {resumeFiles.length > 0 &&
            resumeFiles.map((file, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" noWrap maxWidth={200}>
                  {file.name}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => {
                    setResumeFiles(prev => prev.filter((_, i) => i !== index));
                  }}
                  color="error"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}

            {/* Show message if no file at all */}
            {!uploadedResumeFiles && resumeFiles.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                No attachment
              </Typography>
            )}
          </Box>
        </FormControl>

        

        {applyForm.resumeFile && (
          <Typography variant="body2" sx={{ mb: 2 }}>
            Selected File: {applyForm.resumeFile.name}
          </Typography>
        )}
        {applyError && (
          <Typography color="error" sx={{ mb: 2 }}>
            {applyError}
          </Typography>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleApplyClose} sx={{ mr: 1, fontWeight: 800 }}>Cancel</Button>
          <Button variant="contained" onClick={handleApplySubmit} sx={{ bgcolor: '#0f766e', '&:hover': { bgcolor: '#115e59' }, fontWeight: 800 }}>{isEdit ? 'Update' : 'Submit'}</Button>
        </Box>
      </MuiBox>
    </Modal>

    {/* view model */}
    <Modal open={openViewModal} onClose={handleViewClose}>
    <MuiBox
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        p: 3,
        width: { xs: '90vw', sm: 500 },
        borderRadius: 2,
        boxShadow: 24,
        maxHeight: '90vh',
        overflowY: 'auto',
        border: '1px solid #e2e8f0',
      }}
    >
      <Typography variant="h6" gutterBottom>
        Opportunity Details
      </Typography>
      {viewOpportunity && (
        <Box>
          <Typography><strong>Opportunity #:</strong> {viewOpportunity.opportunity_number}</Typography>
          <Typography><strong>Industry:</strong> {viewOpportunity.industry}</Typography>
          <Typography><strong>Company:</strong> {viewOpportunity.company}</Typography>
          <Typography><strong>Role:</strong> {viewOpportunity.role}</Typography>
          <Typography sx={{ mb: 2 }}><strong>Link:</strong> {viewOpportunity.link}</Typography>
          {/* <Typography><strong>Job Description:</strong> {viewOpportunity.comments}</Typography> */}
          <label
          htmlFor="job-description"
          style={{
            display: 'block',
            marginBottom: 4,
            fontSize: '0.875rem',
            fontWeight: 500,
            color: 'rgba(0, 0, 0, 0.6)', // Matches MUI's default label color
          }}
        >
          Job Description
        </label>
          <div
            style={{
              border: '1px solid rgba(0, 0, 0, 0.23)',
              borderRadius: 4,
              padding: 12,
              minHeight: 144,
              maxHeight: 144,
              overflowY: 'auto',
              marginBottom: 16,
              fontFamily: 'Roboto, sans-serif',
              fontSize: '0.875rem',
              color: 'rgba(0, 0, 0, 0.87)'
            }}
          > 
            <div dangerouslySetInnerHTML={{ __html: viewOpportunity.comments }} />
          </div>
          <Typography><strong>Status:</strong> {viewOpportunity.isActive ? 'Active' : 'Inactive'}</Typography>
        </Box>
      )}
      <Box textAlign="right" mt={2}>
        <Button onClick={handleViewClose} sx={{ fontWeight: 800, color: '#0f766e' }}>Close</Button>
      </Box>
    </MuiBox>
  </Modal>
  </Container>
  </Box>
)
}
export default Opportunity;
